import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { List as UIList } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/List/List";
import { List as MobileFirstUIList } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation/components/List";

import type { listInputs } from "./List.builder";

export type ListProps = BuilderComponentProps<typeof listInputs>;

export const List: FC<ListProps> = (props) => {
  const { isMobileFirstNavigationEnabled } = useConfig();
  const ListComponent = isMobileFirstNavigationEnabled ? MobileFirstUIList : UIList;

  return <ListComponent {...props} />;
};
